import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import daTranslation from "../locales/da/translation.json";
import deTranslation from "../locales/de/translation.json";
import enTranslation from "../locales/en/translation.json";
import esTranslation from "../locales/es/translation.json";
import frTranslation from "../locales/fr/translation.json";
import jaTranslation from "../locales/ja/translation.json";
import nlTranslation from "../locales/nl/translation.json";
import ptBRTranslation from "../locales/ptBR/translation.json";
import trTranslation from "../locales/tr/translation.json";
import itTranslation from "../locales/it/translation.json";
import srTranslation from "../locales/sr/translation.json";
import hrTranslation from "../locales/hr/translation.json";
import bsTranslation from "../locales/bs/translation.json";
import bgTranslation from "../locales/bg/translation.json";
import sqTranslation from "../locales/sq/translation.json";
import mkTranslation from "../locales/mk/translation.json";
import roTranslation from "../locales/ro/translation.json";
import slTranslation from "../locales/sl/translation.json";
import elTranslation from "../locales/el/translation.json";
import bnTranslation from "../locales/bn/translation.json";

export const supportedLngs: { [key: string]: { name: string; locale: string } } = {
    da: {
        name: "Dansk",
        locale: "da-DK"
    },
    de: {
        name: "Deutsch",
        locale: "de-DE"
    },
    en: {
        name: "English",
        locale: "en-US"
    },
    es: {
        name: "Español",
        locale: "es-ES"
    },
    fr: {
        name: "Français",
        locale: "fr-FR"
    },
    ja: {
        name: "日本語",
        locale: "ja-JP"
    },
    nl: {
        name: "Nederlands",
        locale: "nl-NL"
    },
    ptBR: {
        name: "Português Brasileiro",
        locale: "pt-BR"
    },
    tr: {
        name: "Türkçe",
        locale: "tr-TR"
    },
    it: {
        name: "Italiano",
        locale: "it-IT"
    },
    sr: {
        name: "Српски",
        locale: "sr-RS"
    },
    hr: {
        name: "Hrvatski",
        locale: "hr-HR"
    },
    bs: {
        name: "Bosanski",
        locale: "bs-BA"
    },
    bg: {
        name: "Български",
        locale: "bg-BG"
    },
    sq: {
        name: "Shqip",
        locale: "sq-AL"
    },
    mk: {
        name: "Македонски",
        locale: "mk-MK"
    },
    ro: {
        name: "Română",
        locale: "ro-RO"
    },
    sl: {
        name: "Slovenščina",
        locale: "sl-SI"
    },
    el: {
        name: "Ελληνικά",
        locale: "el-GR"
    },
    bn: {
        name: "বাংলা",
        locale: "bn-BD"
    }
};

i18next
    .use(HttpApi)
    .use(LanguageDetector)
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        resources: {
            da: { translation: daTranslation },
            de: { translation: deTranslation },
            en: { translation: enTranslation },
            es: { translation: esTranslation },
            fr: { translation: frTranslation },
            ja: { translation: jaTranslation },
            nl: { translation: nlTranslation },
            ptBR: { translation: ptBRTranslation },
            tr: { translation: trTranslation },
            it: { translation: itTranslation },
            sr: { translation: srTranslation },
            hr: { translation: hrTranslation },
            bs: { translation: bsTranslation },
            bg: { translation: bgTranslation },
            sq: { translation: sqTranslation },
            mk: { translation: mkTranslation },
            ro: { translation: roTranslation },
            sl: { translation: slTranslation },
            el: { translation: elTranslation },
            bn: { translation: bnTranslation }
        },
        fallbackLng: "en",
        supportedLngs: Object.keys(supportedLngs),
        debug: import.meta.env.DEV,
        interpolation: {
            escapeValue: false // not needed for react as it escapes by default
        }
    });

export default i18next;
